import React, { useState } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';

import { FieldV2 } from 'components/common/form-controls';
import { ButtonV2 } from 'components/common/ui';
import { FileDropZone } from 'components/common/media';
import { ModalFooter, ModalFormSection } from 'components/common/modals';
import { LOGISTICS_DOCUMENT_TYPES } from '../constants';
import styles from './LogisticsDocument.styles';

const validationSchema = yup.object().shape({
  documentType: yup.string().required('Required'),
});

export const LogisticsDocumentForm = ({ onSubmit, onCancel }) => {
  const resolver = yupResolver(validationSchema);
  const [documents, setDocuments] = useState([]);

  const methods = useForm({
    defaultValues: {
      documentType: '',
      documents: [],
    },
    resolver,
  });

  const handleDocuments = (files) => {
    setDocuments([...files]);
  };

  const handleSubmit = (values) => {
    onSubmit({ ...values, documents });
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(handleSubmit)}
        id="add-new-document-logistics-form"
      >
        <ModalFormSection>
          <FieldV2
            placeholder="Επιλογή"
            name="documentType"
            control={methods.control}
            label="Document Type"
            type="dropdown"
            isRequired
            disabled={methods.formState.isSubmitting}
            options={LOGISTICS_DOCUMENT_TYPES}
          />
          <FileDropZone
            previewFiles={false}
            callBack={handleDocuments}
            currentFiles={documents}
            accept={{
              'image/png': ['.png'],
              'image/jpg': ['.jpg'],
              'image/jpeg': ['.jpeg'],
              'application/pdf': ['.pdf'],
            }}
            styles={styles}
          />
        </ModalFormSection>
        <ModalFooter>
          <ButtonV2
            variant="secondary"
            onClick={onCancel}
            disabled={methods.formState.isSubmitting}
          >
            Cancel
          </ButtonV2>
          <ButtonV2
            type="submit"
            form="add-new-document-logistics-form"
            loading={methods.formState.isSubmitting}
          >
            OK
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default LogisticsDocumentForm;
